import React from 'react';

const TableRow = ({ data, isEven }) => {
  const bgColor = isEven ? 'bg-white' : 'bg-slate-300';
  const bgColorAlt = isEven ? 'bg-white' : 'bg-indigo-200';
  const bgColorAlt2 = isEven ? 'bg-white' : 'bg-orange-200';
  const bgColorAlt3 = isEven ? 'bg-white' : 'bg-cyan-200';

  return (
    <div className={`flex w-full ${bgColor}`}>
      <div className="w-[20%] min-w-[200px] p-2 text-sm sm:text-base font-medium">
        {data.scope}
      </div>
      <div className={`w-[10%] min-w-[100px] p-2 text-sm sm:text-base whitespace-nowrap ${bgColorAlt}`}>
        {data.hoursUsed}
      </div>
      <div className={`w-[10%] min-w-[100px] p-2 text-sm sm:text-base whitespace-nowrap ${bgColorAlt}`}>
        {data.unitsPlaced}
      </div>
      <div className={`w-[7.5%] min-w-[80px] p-2 text-sm sm:text-base whitespace-nowrap ${bgColorAlt2}`}>
        {data.crewSize}
      </div>
      <div className={`w-[7.5%] min-w-[80px] p-2 text-sm sm:text-base whitespace-nowrap ${bgColorAlt2}`}>
        {data.estCrewDays}
      </div>
      <div className={`w-[10%] min-w-[110px] p-2 text-sm sm:text-base whitespace-nowrap ${bgColorAlt3}`}>
        {data.productionPerDay}
      </div>
      <div className={`w-[10%] min-w-[110px] p-2 text-sm sm:text-base whitespace-nowrap ${bgColorAlt3}`}>
        {data.crewDaysUsed}
      </div>
      <div className={`w-[12.5%] min-w-[150px] p-2 text-sm sm:text-base ${bgColorAlt2}`}>
        {data.rentalEquipment}
      </div>
      <div className={`w-[12.5%] min-w-[150px] p-2 text-sm sm:text-base whitespace-nowrap ${bgColorAlt2}`}>
        {data.rentalEquipmentDays}
      </div>
    </div>
  );
};

export default TableRow;